import * as React from 'react';
import { UIDataModel } from '../uicomponent';
import { UIComponentViewImpl } from '../uicomponentview';
import { ToggleButtonGroupProps, ToggleButtonGroupState, ToggleButtonGroupHandler } from './togglebuttongroupcomponent';
import { ToggleButtonGroupCSSStyle } from './togglebuttongroupcss';
import { ToggleButtonComponent } from '../togglebutton/togglebuttoncomponent';
import './togglebutton-group-style.css';
export class ToggleButtonGroupView extends UIComponentViewImpl<UIDataModel>{

    bindHandlers()
    {
        this.onTabSelected = this.onTabSelected.bind(this);
    }
    draw(uiProps: ToggleButtonGroupProps, uiState: ToggleButtonGroupState, cssStyle: ToggleButtonGroupCSSStyle): JSX.Element | boolean{
        super.draw(uiProps, uiState, cssStyle);
        
        return(
            <div className="scrollmenu" id="toggle-button-group-header" style={cssStyle.getTabHeaderCSSStyle()}>
            {
                uiState.listOfTitles.map((title: string, index: number)=>
                {
                    return <ToggleButtonComponent position={index} key={index} style={uiProps.style} isSelected={uiState.selectedTab === title ? true : false} context={uiProps.context} label={title} onClick={() =>this.onTabSelected(title)}/>;
                })
                
            }
            </div> 
        );
    }

    private onTabSelected(title: string): void
    {
        (this.getUIComponentHandler() as ToggleButtonGroupHandler).onButtonSelected(title);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/togglebuttongroup/togglebuttongroupview.tsx